import { render, staticRenderFns } from "./crud-data.vue?vue&type=template&id=e2c24438&scoped=true&"
import script from "./crud-data.vue?vue&type=script&lang=js&"
export * from "./crud-data.vue?vue&type=script&lang=js&"
import style0 from "./crud-data.vue?vue&type=style&index=0&lang=css&"
import style1 from "./crud-data.vue?vue&type=style&index=1&id=e2c24438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c24438",
  null
  
)

export default component.exports